export default ({space, border}) => {
    let MyBorder = border !== undefined ? border: '3px black dolid';

    return (
        <p className="LineStyle" style={{
            'boxSizing' : 'border-box',
            'display' : 'inline-block',
            'width' : '100%',
            'height' : '1px',
            'gridColumn' : '1/3',
            'border' : '2px gray dashed',
            'margin' : `${space}px 0px`
        }}>

        </p>
    )
}